import(/* webpackMode: "eager" */ "/app/src/app/leaderboard/page.tsx");
